import * as React from 'react';

import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';
import { setToMobile } from '../../redux-state/actions/responsive';


interface DispatchToProps {
    setToMobile: () => void;
}

type ResponsiveProps = DispatchToProps;

export class TransitionMobileBase extends React.Component<ResponsiveProps, any> {

    componentWillMount() {
        this.props.setToMobile();
    }

    /**
     * No need to render anything, since this component is about lifecycle events.
     */
    render() {
        return null
    }
}

function mapDispatchToProps(dispatch): DispatchToProps {
    return {
        setToMobile: () => dispatch(setToMobile())
    }
}

export let ConnectedTransitionMobile = connect<null, DispatchToProps>(null, mapDispatchToProps)(TransitionMobileBase);